export default string => {
    if (typeof string !== 'string') {
        string = string.text;
    }

    return string.replace(/<\/?[^>]+>/ig, '');
};
